
<div class="date-paginator" fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-raised-button class=" m-r-10" (click)="changeDate('prev')"><mat-icon>keyboard_arrow_left</mat-icon></button>
  <input matInput [formControl]="date" readonly>
  <button mat-raised-button class="m-r-10" (click)="changeDate('next')"><mat-icon>keyboard_arrow_right</mat-icon></button>
</div>